export default __webpack_public_path__ + "368ea49b83c3b73250d7beff139f0890.ttf";